import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface BadgeProps {
  children: ReactNode;
  variant?: 'live' | 'paused' | 'archived' | 'error' | 'info' | 'pending';
  className?: string;
  pulse?: boolean;
}

export function Badge({ children, variant = 'info', className, pulse }: BadgeProps) {
  const cls = {
    live: 'badge-live',
    paused: 'badge-paused',
    archived: 'badge-archived',
    error: 'badge-error',
    info: 'badge border-neon-cyan/40 text-neon-cyan bg-neon-cyan/5',
    pending: 'badge border-neon-yellow text-neon-yellow bg-neon-yellow/5',
  }[variant];

  return (
    <span className={cn(cls, className)}>
      {pulse && <span className="pulse-dot" />}
      {children}
    </span>
  );
}

export function StatusBadge({ status }: { status: string }) {
  const v: 'live' | 'paused' | 'archived' | 'error' | 'pending' | 'info' =
    status === 'live' || status === 'active' || status === 'approved' || status === 'paid'
      ? 'live'
      : status === 'paused' || status === 'pending' || status === 'pending_dns' || status === 'pending_ssl'
        ? 'pending'
        : status === 'archived' || status === 'disabled'
          ? 'archived'
          : status === 'rejected' || status === 'reversed' || status === 'error'
            ? 'error'
            : 'info';
  return (
    <Badge variant={v} pulse={v === 'live'}>
      {status.toUpperCase()}
    </Badge>
  );
}
